module.exports = __webpack_public_path__ + "static/img/trash.0771901.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/images/icons/trash.png
// module id = 1474
// module chunks = 2